import React, { useEffect, useState, useCallback, useRef, useMemo } from 'react';
import moment from 'moment';
import { DatePicker } from 'components';
import { Box, Typography, Stack } from '@mui/material';
import Utils from 'commons/utils';
import ApiServices from 'services';
import {
    BsArrowDownCircle,
} from 'react-icons/bs';
import { getColumns } from './columns';
import { ContainerHeader, ButtonExport, ButtonView } from './styles';
import { debounce } from 'lodash';
import { CustomTable } from 'components/custom-table';

const START_DATE = moment().startOf('month').format();
const END_DATE = moment().endOf('date').format();

const DEFAULT_FILTER = {
    // pageNumber: 1,
    // pageSize: 10,
    fromDate: START_DATE,
    toDate: END_DATE,
};

function KPITotalPerformanceRp() {
    const [dataList, setDataList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [filter, setFilter] = useState(DEFAULT_FILTER);
    const [dataFilter, setDataFilter] = useState([]);
    // search Date
    const [startDate, setStartDate] = useState(START_DATE);
    const [endDate, setEndDate] = useState(END_DATE);

    const initData = (query) => {
        setLoading(true);
        return ApiServices.getKpiTotalPerformanceReport(query ? query : filter)
            .then((res) => {
                if (res) {
                    if (totalRecords !== res?.data?.length) setTotalRecords(res?.data?.length);
                    setDataList(res?.data || []);
                    setDataFilter(res?.data || []);
                }
            })
            .catch((err) => console.warn('get KPI total report:', err))
            .finally(() => setLoading(false));
    };

    const debouncedFilter = useMemo(() => debounce((value, name) => {
        if (!value || !name) {
            reloadData();
            return;
        }
        const filtered = dataList.filter((item) => {
            const fieldValue = item[name];
            return fieldValue && fieldValue.toString().toLowerCase().includes(value.toLowerCase());
        });
        setDataFilter(filtered);
    }, 300), [dataList]);

    const handleSearchColumn = (event) => {
        const { value, name } = event.target;
        debouncedFilter(value, name);
    };

    useEffect(() => {
        return () => {
            debouncedFilter.cancel();
        };
    }, [debouncedFilter]);

    const timeoutGetData = useCallback(
        debounce((newFilter) => {
            initData(newFilter);
        }, 1000),
        [],
    );
    useEffect(() => {
        timeoutGetData(filter);
    }, [filter]);

    const reloadData = async () => {
        return await initData(filter);
    };

    const handleChangeStartDate = useCallback(
        (event) => {
            setStartDate(event.target.value);
        },
        [startDate],
    );
    const handleChangeEndDate = useCallback(
        (event) => {
            setEndDate(event.target.value);
        },
        [endDate],
    );

    const handleSearchDate = (startDateSearch, endDateSearch) => {
        console.log({ startDateSearch, endDateSearch });
        if (!startDateSearch || !endDateSearch) return;
        setFilter((prev) => ({ ...prev, fromDate: startDateSearch, toDate: endDateSearch }));
    };

    const handleExportClient = () => {
        setLoading(true);
        return ApiServices.exportGetKpiTotalPerformanceReport()
            .then((res) => {
                if (res?.data) {
                    Utils.exportTemplate(
                        res?.data,
                        `BC_hiệu_suất_bán_hàng_theo_KH${Utils.formatSimpleDate(moment())}.xlsx`,
                    );
                }
            })
            .catch((err) => {
                console.log('Export Client file error:', err);
                window.UIMessage?.error('Tải thất bại !!!');
            })
            .finally(() => setLoading(false));
    };

    const renderHeader = () => (
        <>
            <ContainerHeader>
                <Stack spacing={2} direction="row">
                    <Box sx={{ width: '160px' }}>
                        <DatePicker
                            sx={{
                                marginBottom: '10px',
                                padding: 0,
                            }}
                            width={100}
                            marginTop="0"
                            size="small"
                            onChange={handleChangeStartDate}
                            value={startDate}
                            error={true}
                            label="Từ ngày"
                        />
                    </Box>
                    <Box sx={{ width: '160px' }}>
                        <DatePicker
                            sx={{
                                marginBottom: '10px',
                                padding: 0,
                            }}
                            width={100}
                            marginTop="0"
                            size="small"
                            onChange={handleChangeEndDate}
                            value={endDate}
                            error={true}
                            label="Đến ngày"
                        />
                    </Box>

                    <ButtonView
                        onClick={() => handleSearchDate(startDate, endDate)}
                        sx={{ width: { xs: '100%', sm: 'auto' } }}
                    >
                        Xem
                    </ButtonView>

                </Stack>
            </ContainerHeader>
            <ButtonExport
                variant="outlined"
                startIcon={<BsArrowDownCircle />}
                onClick={handleExportClient}
            >
                Tải excel
            </ButtonExport>
        </>
    );

    return (
        <>
            <Box sx={{ width: '100%' }}>
                <Typography variant="h6" component="h6" sx={{ marginBottom: '10px' }}>
                    Báo cáo hiệu suất bán hàng theo khách hàng
                </Typography>
                <CustomTable
                    filter={filter}
                    rows={dataFilter}
                    headCells={getColumns(handleSearchColumn)}
                    totalRecords={totalRecords}
                    onPageChange={(paging) => {
                        setFilter((prev) => ({ ...prev, ...paging }));
                    }}
                    loading={loading}
                    renderHeader={renderHeader}
                />
            </Box>
        </>
    );
}
export { KPITotalPerformanceRp };
